<template>
  <!-- 历史记录 -->
  <div class="history">
    <!-- 头部 -->
    <Header :title="$lang.history" @back="closeHistory">
      <div slot="rightArea" @click="showDateSelect = true" v-if="$route.query.platformUserType !== 7">{{ $lang.date }}</div>
    </Header>
    <!-- 聊天内容区域 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="disabled" ref="history-content" id="history-content">
      <MessageList :list="chatRecord" :history="true" />
    </van-pull-refresh>
    <van-calendar :title="$lang.chatDateRange" v-model="showDateSelect" type="range" :default-date="[new Date(startTime), new Date(endTime)]" @confirm="onDateChange" :color="$theme.topicColor" :min-date="new Date(Date.now() - 622080000000)" :max-date="new Date()" :allow-same-day="true" />
  </div>
</template>

<script>
import $ from 'jquery'
import MessageList from './MessageList'
import {queryChatHistoryRecord} from '../api/index'
import formatDateByTimestamp from '../utils/formatDateByTimestamp.js'
export default {
  components: {
    MessageList
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  created () {
    this.initData()
  },
  data () {
    return {
      showDateSelect: false,
      startTime: formatDateByTimestamp(Date.now() - (1000 * 60 * 60 * 24 * 365)),
      endTime: formatDateByTimestamp(Date.now()),
      isLoading: false,
      disabled: true,
      chatRecord: [],
      currentPage: 1
    }
  },
  methods: {
    // 修改筛选日期
    onDateChange (dateArray) {
      this.startTime = formatDateByTimestamp(dateArray[0].getTime())
      this.endTime = formatDateByTimestamp(dateArray[1].getTime())
      this.showDateSelect = false
      this.chatRecord = []
      this.currentPage = 1
      this.initData()
    },
    closeHistory () {
      this.$emit('close')
    },
    // 历史记录滚动到底部
    scrollBottom () {
      $('#history-content').animate({
        scrollTop: 100000
      }, 200)
    },
    onRefresh () {
      this.currentPage = this.currentPage + 1
      this.initData()
    },
    // 简化历史记录的数据结构
    handleHistoryData (data) {
      data.forEach(item => {
        // 是否是我发送的消息
        item.isMe = Boolean(item.fromAccount === this.userInfo.userID)
        // 消息类型
        item.messageType = item.msgBody[0].msgType
        let msgContent = item.msgBody[0].msgContent[0]
        // 文本消息
        item.messageText = msgContent.text
        // 自定义消息
        item.courseInfo = msgContent.date ? JSON.parse(msgContent.date) : {}
        // 图片消息
        item.imgUrl = msgContent.imageInfoArray && msgContent.imageInfoArray[0].url
        item.imgUrl = item.imgUrl && item.imgUrl.split('?Expires=')[0]
        // 文件消息
        item.fileName = msgContent.fileName
        item.fileUrl = msgContent.url
        item.fileUrl = item.fileUrl && item.fileUrl.split('?Expires=')[0]
        // 视频消息
        item.videoUrl = msgContent.videoUrl
        item.videoUrl = item.videoUrl && item.videoUrl.split('?Expires=')[0]
      })
      return data
    },
    initData () {
      let data = {
        userId: this.userInfo.userID,
        currentPage: this.currentPage,
        pageSize: 30,
        isUserFlag: 1,
        startTime: this.startTime,
        endTime: this.endTime
      }
      queryChatHistoryRecord(data).then(res => {
        if (res.data.resultCode === 0) {
          let total = res.data.totalCount
          let chatRecord = res.data.resultData
          this.chatRecord = this.handleHistoryData(chatRecord).concat(this.chatRecord)
          this.currentPage === 1 && this.scrollBottom()
          this.disabled = Boolean(this.chatRecord.length >= total)
        }
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
// 历史记录
.history{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F9F9F9;
  z-index: 200;
  #history-content{
    position: relative;
    flex: 1;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/History.vue